/*
 * @Date: 2020-08-31 14:11:53
 * @Author: MX
 * @LastEditTime: 2020-08-31 19:41:19
 * @Description: mutation-types
 */
export const LOGIN_INIT = 'LOGIN_INIT'
export const SET_USER = 'SET_USER'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_UUID = 'SET_UUID'
export const LOGIN_OUT = 'LOGIN_OUT'